/** Underline-tab look (matches `features/tasks`' `ColumnSelectorPanel` tabs) — overrides the default shadcn pill style. */
export const UNDERLINE_TABS_LIST_CLASS =
  'w-full justify-start rounded-none border-b bg-transparent px-0';

export const UNDERLINE_TABS_TRIGGER_CLASS =
  'rounded-none border-b-2 border-transparent text-muted-foreground data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none';
